import { useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import { haveValue } from "../../helper/common";
import DatePicker from "react-datepicker";

const PropertyRentDetails = (props) => {
  const { property, sharedProfile, formData, setFormData, handleNextStep } =
    props;
  const { _t } = useTranslator();

  const [error, setError] = useState(false);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth().toString().padStart(2, "0"); // Adding 2 to get month as it is zero-based and payment to start from next month

  const minDate = currentDate.toISOString().split("T")[0];

  const handleChangeInput = (e) => {
    if (error) {
      setError(false);
    }
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleReview = (e) => {
    e.preventDefault();
    if (
      !haveValue(formData?.payment_start) ||
      !haveValue(formData?.rent_amount) ||
      !haveValue(formData?.deposit_amount)
    ) {
      setError(true);
    } else {
      handleNextStep();
    }
  };

  return (
    <>
      <div className="rental-datails">
        <h2>{_t("rentalDetails")}</h2>
        <h6>{_t("pleaseProvideYourRentalMoveInDetails")}</h6>
        <form className="details-form" onSubmit={handleReview}>
          <div className="row">
            <div className="col-lg-12">
              <label htmlFor="movein_address">
                {" "}
                {_t("moveInAddress")}
                <span>*</span>{" "}
              </label>
              <input
                type="text"
                placeholder={_t("enterAddress")}
                name="movein_address"
                disabled
                value={`${property?.street} - ${
                  Number.isNaN(parseInt(property?.street_number, 10))
                    ? "N/A"
                    : String(parseInt(property?.street_number, 10))
                }, ${property?.floor_number}-${property?.flat_number}`}
              />
            </div>
            <div className="col-lg-12">
              <label htmlFor="tenant">
                {" "}
                {_t("tenant")}
                <span>*</span>{" "}
              </label>
              <input
                type="text"
                placeholder={_t("enterTenantName")}
                name="tenant"
                disabled
                value={`${
                  haveValue(sharedProfile?.tenantid?.fname)
                    ? sharedProfile?.tenantid?.fname
                    : ""
                } ${
                  haveValue(sharedProfile?.tenantid?.lname)
                    ? sharedProfile?.tenantid?.lname
                    : ""
                }`}
              />
            </div>
            <div className="col-lg-6">
              <label htmlFor="payment_start">
                {_t("leaseStartDate")}
                <span>*</span>
              </label>
              <div className="native-like-datepicker">
                <DatePicker
                  id="payment_start"
                  name="payment_start"
                  selected={
                    formData?.payment_start
                      ? new Date(formData.payment_start)
                      : null
                  }
                  onChange={(date) =>
                    handleChangeInput({
                      target: {
                        name: "payment_start",
                        value: date ? date.toISOString().split("T")[0] : "",
                      },
                    })
                  }
                  dateFormat="dd/MM/yyyy"
                  minDate={minDate}
                  placeholderText="dd/mm/yyyy"
                  className={`date-input cursor-pointer ${
                    !haveValue(formData?.payment_start) ? "empty" : ""
                  }`}
                  showPopperArrow={false}
                  popperPlacement="bottom-start"
                />
                <span className="calendar-icon cursor-pointer">
                  <img src="/images/calendar-icon.svg" alt="Calendar Icon" />
                </span>
              </div>
            </div>
            <div className="col-lg-6">
              <label htmlFor="lease_end">{_t("leaseEndDate")}</label>
              <input
                type="date"
                name="lease_end"
                onChange={handleChangeInput}
                value={formData.lease_end}
              />

              <div className="native-like-datepicker">
                <DatePicker
                  id="lease_end"
                  name="lease_end"
                  selected={
                    formData?.lease_end ? new Date(formData.lease_end) : null
                  }
                  onChange={(date) =>
                    handleChangeInput({
                      target: {
                        name: "lease_end",
                        value: date ? date.toISOString().split("T")[0] : "",
                      },
                    })
                  }
                  dateFormat="dd/MM/yyyy"
                  placeholderText={`dd/mm/yyyy`}
                  className={`date-input cursor-pointer ${
                    !haveValue(formData?.lease_end) ? "empty" : ""
                  }`}
                  showPopperArrow={false}
                  popperPlacement="bottom-start"
                />
                <span className="calendar-icon cursor-pointer">
                  <img src="/images/calendar-icon.svg" alt="Calendar Icon" />
                </span>
              </div>
            </div>

            <div className="col-lg-12">
              <label htmlFor="">
                {_t(
                  "isItASharedHousehold",
                  "question asked while awarding property",
                )}
                <span>*</span>
              </label>
              <div className="check-radio">
                <div class="form-check radio-check">
                  <label>
                    <input
                      type="radio"
                      name="shared_household"
                      value="yes"
                      onChange={handleChangeInput}
                      checked={formData.shared_household == "yes"}
                    />
                    {_t("yes")}
                  </label>
                </div>
                <div class="form-check radio-check">
                  <label>
                    <input
                      type="radio"
                      name="shared_household"
                      value="no"
                      onChange={handleChangeInput}
                      checked={formData.shared_household == "no"}
                    />
                    {_t("no")}
                  </label>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <label htmlFor="rent_amount">
                {_t("rentalPaymentAmount")}
                <span>*</span>
              </label>
              <input
                type="number"
                name="rent_amount"
                placeholder={_t("enterPaymentAmount")}
                onChange={handleChangeInput}
                value={formData.rent_amount}
              />
            </div>
            <div className="col-lg-6">
              <label htmlFor="deposit_amount">
                {_t("depositAmount")}
                <span>*</span>
              </label>
              <input
                type="number"
                name="deposit_amount"
                placeholder={_t("enterDepositAmount")}
                onChange={handleChangeInput}
                value={formData.deposit_amount}
              />
            </div>
          </div>

          {error && (
            <p className="text-danger alert-text">
              {" "}
              {_t("allFieldsAreMandatoryToBeFilled")}.{" "}
            </p>
          )}
          <button className="btn btngreen">{_t("reviewDetails")}</button>
        </form>
      </div>
    </>
  );
};

export default PropertyRentDetails;
